import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./CoachDetailsTrainingLocations.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import CustomMap from "../../components/CustomMap/CustomMap";
import { ArrowUpRightBlue } from "../../constant/imagePath";

export const CoachDetailsTrainingLocations = ({ data }) => {
  const [myCoords, setCoords] = useState({ lat: 40.73061, lng: -73.935242 });

  function getLocation() {
    navigator.geolocation.getCurrentPosition((pos) => {
      setCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    });
  }
  useEffect(() => {
    getLocation();
  }, []);

  return (
    <div className={classes.trainingContainer}>
      <h4
        style={{
          ...Fonts.h4f26,
          color: Colors.neutralShadesOfNero,
        }}
      >
        Training Locations
      </h4>
      <div className={classes.mapContainer}>
        <CustomMap myCoords={myCoords} borderRadius={10} />
      </div>

      <div className={classes.locations}>
        {data?.map((item) => {
          return (
            <div className={classes.locationsBox}>
              <h6 style={{ ...Fonts.h7, fontFamily: 'inter-600', lineHeight: '24px', color: Colors.neutralShadesOfNero }}>
                {item?.displayName}
              </h6>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                {item?.address}
              </p>
              <span
                style={{
                  ...Fonts.h7,
                  fontFamily: "inter-500",
                  color: Colors.mainBlue,
                }}
              >
                Get directions <img src={ArrowUpRightBlue} />
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

CoachDetailsTrainingLocations.propTypes = {
  data: PropTypes.array,
};

CoachDetailsTrainingLocations.defaultProps = {
  data: [
    {
      displayName: "Royal Tennis Court",
      address: `DeWitt Clinton Park, W 54th St, New York, NY`,
      latitude: "",
      longitude: "",
    },
    {
      displayName: `Riverbank State Park Tennis Courts`,
      address: `DeWitt Clinton Park, W 54th St, New York, NY`,
      latitude: "",
      longitude: "",
    },
  ],
};
